import { render, staticRenderFns } from "./FileDetailModal.vue?vue&type=template&id=dcc5caa2&scoped=true&"
import script from "./FileDetailModal.vue?vue&type=script&lang=js&"
export * from "./FileDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./FileDetailModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FileDetailModal.vue?vue&type=style&index=1&id=dcc5caa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc5caa2",
  null
  
)

export default component.exports